/**
 * The voice vendors that can run a Nava interview or check-in: VAPI, the vendor
 * every conversation ran on before this seam existed, and ElevenLabs
 * Conversational AI.
 */
export const VOICE_PROVIDERS = ['vapi', 'elevenlabs'];
/** Everything provisioned before the seam existed runs on VAPI. */
export const DEFAULT_VOICE_PROVIDER = 'vapi';
export function isVoiceProvider(value) {
    return typeof value === 'string' && VOICE_PROVIDERS.includes(value);
}
//# sourceMappingURL=VoiceProvider.js.map